import React from 'react';
import { AppBar, Toolbar, Box, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';

const HeaderBar = () => {
  return (
    <AppBar
      position='sticky'
      sx={{ backgroundColor: '#090928', width: '100%' }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img src='/images/logo_big.png' alt='Logo' width={80} />
          <Box sx={{ ml: 4, color: 'white', display:'flex' }}>
            <Box display='flex' alignItems='center' gap={1}>
              <LocationOnIcon sx={{ color: 'white' }} />
              <Typography variant='body2'>
                630 Herman Rd, Jackson Township, NJ 08527
              </Typography>
            </Box>
            <Box display='flex' alignItems='center' gap={1} marginLeft={2}>
              <PhoneIcon sx={{ color: 'white' }} />
            <Typography variant='body2'>(718) 437-3633</Typography>
            </Box>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderBar;
